// extracted by mini-css-extract-plugin
export var border = "HeaderNavItem-module--border--1rAGZ";
export var bxTextTruncateEnd = "HeaderNavItem-module--bx--text-truncate--end--2_G_0";
export var bxTextTruncateFront = "HeaderNavItem-module--bx--text-truncate--front--3249n";
export var currentPage = "HeaderNavItem-module--currentPage--4HDp7";
export var currentPageAccordion = "HeaderNavItem-module--currentPageAccordion--3SUYy";
export var menuItem = "HeaderNavItem-module--menuItem--23U9P";